export enum LocalStorageKeyEnum {
  SEEN_NEW_COMPANIES_MODAL = '@hapvida/seen-new-companies-modal',
  ACCOUNT_DATA = '@hapvida/account-data',
}
